<template>
	<div class="housing_options_box" id="housing_options">
		<div class="housing_options_card_box">
			<div class="housing_options_card" @click="chalet_click">
				<img class="housing_options_card_bg_img" :src="require('../assets/img/services/service1.jpg')" alt="">
				<div class="housing_options_card_shadow"></div>
				<div class="housing_options_card_title">Шале</div>
				<div class="housing_options_card_content">
					<div class="housing_options_card_icon">
						<img src="../assets/img/housing_options/Иконка Номер.svg" alt=""/>
						<p>ПОДРОБНЕЕ</p>
					</div>
					<div class="housing_options_card_description">
						дом в европейском стиле с панорамным видом на акваторию
					</div>
				</div>
			</div>
			<div class="housing_options_card" @click="suite_click" style="border: 1px solid rgba(244,210,167,0.85);">
				<img class="housing_options_card_bg_img" :src="require('../assets/img/services/service2.jpg')" alt="">
				<div class="housing_options_card_shadow"></div>
				<div class="housing_options_card_title">Номера</div>
				<div class="housing_options_card_content">
					<div class="housing_options_card_icon">
					<img src="../assets/img/housing_options/Иконка шале.svg" alt=""/>
					<p>ПОДРОБНЕЕ</p>
					</div>
					<div class="housing_options_card_description">
						дизайнерские номера с панорамным видом на жителей океанариума и всем необходимым
						для комфортного проживания и стандартные номера для нескольких человек,
						часть из которых расположены в мансарде
					</div>
				</div>
			</div>
			<div class="housing_options_card" @click="capsule_click">
				<img class="housing_options_card_bg_img" :src="require('../assets/img/services/service3.jpg')" alt="">
				<div class="housing_options_card_shadow"></div>
				<div class="housing_options_card_title">Капсульные<br>домики</div>
				<div class="housing_options_card_content">
					<div class="housing_options_card_icon">
						<img src="../assets/img/housing_options/Иконка капсулы.svg" alt=""/>
						<p>ПОДРОБНЕЕ</p>
					</div>
					<div class="housing_options_card_description">
						круглогодичный отдельный модульный дом, в формате cinema capsula
						с проектором и панорамными окнами
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>

export default {
	name: "HousingOptionsComponent",
	data() {
		return {

		}
	},
	created() {
		console.log()
	},
	computed: {
		housing_items: {
			get() {
				return this.$store.state.housing_items
			},
			set()  {
				this.$store.commit('GetHousingItemsAction', this.housing_items)
			}
		},
		housing_items_chalet() {
			return this.housing_items.filter(item  => item.type.name ==='chalet')[0]
		},
		housing_items_suite() {
			return this.housing_items.filter(item  => item.type.name ==='suite')
		},
		housing_items_capsule() {
			return this.housing_items.filter(item  => item.type.name ==='capsule')[0]
		},
		item_img_active() {
			return this.housing_item_active.imgs.find(item => item.active  === true)
		},
		housing_item_active() {
			let active_itm = this.housing_items.find(item => item.active === true)
			active_itm.imgs[0].active = true
			return active_itm
		}
	},
	methods: {
		trackGoal(target) {
			/* eslint-disable no-undef */
			if (typeof ym === 'function') {
				ym(109723241, 'reachGoal', 'housing_click', { target: target });
			}
		},
		suite_click()  {
			/* eslint-disable no-undef */
			if (typeof ym === 'function') { ym(109723241, 'reachGoal', 'housing_suite'); }
			this.housing_item_active.active = false
			this.housing_items_suite[0].active = true
			this.$router.push({ name: 'housing_option', params: { id:  this.housing_items_suite[0].id} })

			// this.$route.push({to: ''})
		},
		chalet_click()  {
			/* eslint-disable no-undef */
			if (typeof ym === 'function') { ym(109723241, 'reachGoal', 'housing_chalet'); }
			this.housing_item_active.active = false
			this.housing_items_chalet.active = true
			this.$router.push({ name: 'housing_option', params: { id:  this.housing_items_chalet.id} })
			// this.$router.push({ name: 'Movement', params: { id: movement.id }}).catch(()=>{})
		},
		capsule_click()  {
			/* eslint-disable no-undef */
			if (typeof ym === 'function') { ym(109723241, 'reachGoal', 'housing_capsule'); }
			this.housing_item_active.active = false
			this.housing_items_capsule.active = true
			this.$router.push({ name: 'housing_option', params: { id:  this.housing_items_capsule.id} })
		},
		handle_menu_click(menu_item) {
			if (!menu_item.active) {
				this.housing_item_active.active = false
				this.housing_items_suite.find(item => item.id  ===  menu_item.id).active = true
			}
		},
		handle_order_click() {
			this.$scrollTo('#booking_box', {duration: 300})
			setTimeout(() => {
				this.$store.dispatch('isModalShowAction', true)
			}, 300)

		},

		gallery_control_prew(img) {
			let active_img_idx = this.housing_item_active.imgs.indexOf(img)
			let imgs = this.housing_item_active.imgs
			let active_img_prew_idx = active_img_idx - 1
			if (active_img_prew_idx >= 0)  {
				imgs[active_img_idx].active = false
				imgs[active_img_prew_idx].active = true
			} else {
				console.log('error this is a first image')
			}
			this.housing_item_active.imgs = imgs
			// console.log(this.housing_item_active.imgs)
		},
		gallery_control_next(img) {
			let active_img_idx = this.housing_item_active.imgs.indexOf(img)
			let imgs = this.housing_item_active.imgs
			let active_img_next_idx = active_img_idx + 1
			if (active_img_next_idx < this.housing_item_active.imgs.length) {
				this.housing_item_active.imgs[active_img_idx].active = false
				this.housing_item_active.imgs[active_img_next_idx].active = true
			} else {
				console.log('error this is a last image')
			}
			this.housing_item_active.imgs = imgs
			console.log(this.housing_item_active.imgs)
		},

		suite_control_prew() {
			let active_idx = this.housing_items_suite.indexOf(this.housing_item_active)
			if (active_idx  ===  0) {
				console.log('error this is the first suite')
			} else  {
				let active_idx_prew = active_idx - 1
				this.housing_items_suite[active_idx].active = false
				this.housing_items_suite[active_idx_prew].active = true
			}
		},
		suite_control_next()  {
			let active_idx = this.housing_items_suite.indexOf(this.housing_item_active)
			if (active_idx === this.housing_items_suite.length -1) {
				console.log('error this is the last suite')
			} else  {
				let active_idx_next = active_idx + 1
				this.housing_items_suite[active_idx].active = false
				this.housing_items_suite[active_idx_next].active = true
			}
		}
	},
}
</script>
<style >

.fadeOut {
	animation: fadeOut 0.3s ease-out;
}

@keyframes fadeOut  {
	0%  {
		opacity: 1;
	}
	100%   {
		opacity: 0;
	}
}


.fadeIn {
	animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn  {
	0%  {
		opacity: 0;
	}
	100%   {
		opacity: 1;
	}
}

.fade-text-enter-active,
.fade-text-fade-leave-active {
	transition: opacity 0.2s ease-out;
	opacity: 1;
}

.fade-text-enter,
.fade-text-leave-to { /* .fade-leave-active below version 2.1.8 */
	opacity: 0;
}


.fade-text-enter-active,
.fade-text-leave-active {
	transition: all 0.2s ease-out;
	opacity: 1;
}

.fade-text-enter,
.fade-text-leave-to { /* .fade-leave-active below version 2.1.8 */
	opacity: 0;
}


.housing_options_box {
	background-color: #F7F3ED;
	color: #333333;
	position: relative;
	min-height: 550px;
	width: 100%;
	margin-top: 2em;
}
.housing_options_card_box {
	/*padding: 1em;*/
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
    flex-flow: row nowrap;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
	z-index: 1;
	color: #FFFFFF;
}

.housing_options_card_box > article {
	margin: 1em;
}
.housing_options_card:hover {
	/*background-size: 110% 110%;*/
}
.housing_options_card:hover .housing_options_card_shadow {
	opacity: 0;
}

.housing_options_card_bg_img {
	position: absolute;
	transition: all 0.5s ease;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	height: 100%;
	width: 100%;
	z-index: 1;
	object-fit: cover;
	filter: blur(3px);
	transform: scale(1.05);
}

.housing_options_card:hover .housing_options_card_bg_img {
	transform: scale(1.1);
	filter: blur(0);
}


.housing_options_card {
	overflow: hidden;
	transition: all 0.5s ease;
	box-sizing: border-box;
	color: #FFFFFF;
	position: relative;
    top: 0;
    height: 100%;
    width: 33.33%;
    padding: 1em;
    text-align: center;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
}
.housing_options_card_shadow {
	transition: opacity 0.5s ease;
	opacity: 1;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	background-color: rgba(44, 51, 51, 0.35);
}
.housing_options_card_title {
	font-size: 2.2em;
	padding-top: 3em;
	font-weight: 400;
	letter-spacing: 0.1em;
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	min-height: 7em;
	text-shadow: 0px 0px 15px black;
}

.housing_options_card_content {
	z-index: 2;
}

.housing_options_card_icon p {
	color: #FFFFFF;
	text-shadow: color(srgb 0.275 0.2458 0.1939) 1px 1px 4px;
	font-size: 1.5em;
	letter-spacing: 0.1em;
	transition: all 0.5s ease;
	margin: 0em;
	padding: 0;
	height: 0px;
	opacity: 0;
	overflow: hidden;
	font-weight: 400;
}
.housing_options_card_icon {
	cursor: pointer;
}
.housing_options_card:hover .housing_options_card_icon p {
	height: 2em;
	opacity: 1;
	padding-top: 0.5em;
}

.housing_options_card_description {
	width: 68%;
	margin: auto;
	font-size: 0.75em;
	padding: 1em 0;
	min-height: 16em;
	text-shadow: 0px 0px 15px black;
}


.housing_item_box_menu_item > .housing_item_box_menu_item_border.active,
.housing_item_box_menu_item:hover > .housing_item_box_menu_item_border {
	width: 100%;
	opacity: 1;
}


@media (max-width: 575px) {

	.housing_options_card_box {
		/*padding: 1em; *!*/
		width: 100%;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-flow: row nowrap;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: center;
		z-index: 1;
		align-items: stretch;
		align-content: center;

	}
	.housing_options_card {
		overflow: hidden;
		box-sizing: border-box;
		color: #FFFFFF;
		text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
		position: relative;
		top: 0;
		height: 100%;
		width: 100%;
		padding: 1em;
		text-align: center;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-between;
		align-items: center;
		border: none !important;
	}
	.housing_options_card_shadow {
		display: none;
	}
	.housing_options_card_bg_img {
		position: absolute;
		transition: all 0.5s ease;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		height: 100%;
		width: 100%;
		z-index: 1;
		object-fit: cover;

	}
	.housing_options_card_description {
		font-size: 0.8em;
	}
}
@media (min-width: 576px) {
	.housing_options_box {
		height: 80vh;
	}
}
</style>